@if (infoService.lastOpenMessage(); as message) {
  @if (message.severity !== 'alert') {
    <div
      class="message-block row"
      [class.floating]="floating"
      [class]="message.severity"
      animate.enter="fade-in"
      animate.leave="fade-out"
    >
      <mat-icon fontSet="material-symbols-rounded" [ngClass]="message.severity">{{
        severityIcons[message.severity || 'info']
      }}</mat-icon>
      <div class="flex">
        @for (messageItem of showMessages(message); track $index) {
          <p>
            {{ messageItem.message | translateAsync: messageItem.params }}
          </p>
        }
      </div>

      <button type="button" mat-icon-button (click)="close(message.id)">
        <mat-icon fontSet="material-symbols-rounded">close</mat-icon>
      </button>
    </div>
  }
}
